import React from "react";

import Placeholder, { Rect } from "components/Placeholder";
import { MenuCardSkeleton } from "components/Shared/Skeletons";

const LoadingSkeleton = () => {
  return (
    <>
      <div className="mb-lg">
        <Placeholder width="100%" height="48">
          <Rect width="60" height="20" />
          <Rect y="24" width="260" height="24" />
        </Placeholder>
      </div>
      <div>
        <div className="flex">
          <div className="mr-md">
            <Placeholder width="48" height="48">
              <Rect width="48" height="48" />
            </Placeholder>
          </div>
          <div>
            <Placeholder width="100%" height="72">
              <Rect width="132" height="24" />
              <Rect y="28" width="260" height="20" />
              <Rect y="52" width="260" height="20" />
            </Placeholder>
          </div>
        </div>
      </div>
      <div className="flex flex-row overflow-auto lg:overflow-hidden mb-lg -mx-sm p-sm pb-md scroll-px-sm">
        <ul className="inline-flex lg:flex -mr-sm lg:mr-none">
          {new Array(3).fill(null).map((_, i) => {
            return (
              <li className="flex-shrink-0 mr-md" key={i}>
                <MenuCardSkeleton className="bg-white shadow-low rounded" />
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export const DeliveryMenuLoadingSkeleton: React.FC = () => {
  const items = ["a", "b", "c", "d", "e", "f"];
  return (
    <>
      {items.map((n: string) => (
        <LoadingSkeleton key={n} />
      ))}
    </>
  );
};

export default DeliveryMenuLoadingSkeleton;
